import { createAction } from '@reduxjs/toolkit';

import types from '@constants/action-types';
import { actionRequestFactory, actionResponseFactory } from '@factories';

export const createSavedFilingPeriodRequest = payload =>
  actionRequestFactory(types.CREATE_SAVED_FILING_PERIOD_REQUEST, payload);
export const createSavedFilingPeriodSuccess = response =>
  actionResponseFactory(types.CREATE_SAVED_FILING_PERIOD_SUCCESS, { response });
export const createSavedFilingPeriodFailure = error =>
  actionResponseFactory(types.CREATE_SAVED_FILING_PERIOD_FAILURE, { error });

export const getSavedFilingPeriodFileRequest = payload =>
  actionRequestFactory(types.GET_SAVED_FILING_PERIOD_FILE_REQUEST, payload);
export const getSavedFilingPeriodFileSuccess = response =>
  actionResponseFactory(types.GET_SAVED_FILING_PERIOD_FILE_SUCCESS, { response });
export const getSavedFilingPeriodFileFailure = error =>
  actionResponseFactory(types.GET_SAVED_FILING_PERIOD_FILE_FAILURE, { error });

export const deleteSavedFilingPeriodFileRequest = payload =>
  actionRequestFactory(types.DELETE_SAVED_FILING_PERIOD_FILE_REQUEST, payload);
export const deleteSavedFilingPeriodFileSuccess = response =>
  actionResponseFactory(types.DELETE_SAVED_FILING_PERIOD_FILE_SUCCESS, response);
export const deleteSavedFilingPeriodFileFailure = response =>
  actionResponseFactory(types.DELETE_SAVED_FILING_PERIOD_FILE_FAILURE, response);

export const listSavedFilingPeriodFilesRequest = payload =>
  actionRequestFactory(types.LIST_SAVED_FILING_PERIOD_FILES_REQUEST, payload);
export const listSavedFilingPeriodFilesSuccess = response =>
  actionResponseFactory(types.LIST_SAVED_FILING_PERIOD_FILES_SUCCESS, { response });
export const listSavedFilingPeriodFilesFailure = error =>
  actionResponseFactory(types.LIST_SAVED_FILING_PERIOD_FILES_FAILURE, { error });

export const processSavedFilingPeriodRequest = payload =>
  actionRequestFactory(types.PROCESS_SAVED_FILING_PERIOD_REQUEST, payload);
export const processSavedFilingPeriodSuccess = response =>
  actionResponseFactory(types.PROCESS_SAVED_FILING_PERIOD_SUCCESS, { response });
export const processSavedFilingPeriodFailure = error =>
  actionResponseFactory(types.PROCESS_SAVED_FILING_PERIOD_FAILURE, { error });

export const getSavedFilingPeriodByIdRequest = id =>
  actionRequestFactory(types.GET_SAVED_FILING_PERIOD_BY_ID_REQUEST, id);
export const getSavedFilingPeriodByIdSuccess = savedFilingPeriod =>
  actionResponseFactory(types.GET_SAVED_FILING_PERIOD_BY_ID_SUCCESS, { savedFilingPeriod });
export const getSavedFilingPeriodByIdFailure = error =>
  actionResponseFactory(types.GET_SAVED_FILING_PERIOD_BY_ID_FAILURE, { error });

export const updateSavedFilingPeriodByIdRequest = payload =>
  actionRequestFactory(types.UPDATE_SAVED_FILING_PERIOD_BY_ID_REQUEST, payload);
export const updateSavedFilingPeriodByIdSuccess = savedFilingPeriod =>
  actionResponseFactory(types.UPDATE_SAVED_FILING_PERIOD_BY_ID_SUCCESS, { savedFilingPeriod });
export const updateSavedFilingPeriodByIdFailure = error =>
  actionResponseFactory(types.UPDATE_SAVED_FILING_PERIOD_BY_ID_FAILURE, { error });

export const resetSavedFilingPeriod = () =>
  actionRequestFactory(types.RESET_SAVED_FILING_PERIOD, undefined);
export const resetFiles = () => actionRequestFactory(types.RESET_FILES, []);

export const listSavedFilingPeriodSpreadsheetsRequest = payload =>
  actionRequestFactory(types.LIST_SAVED_FILING_PERIOD_JSON_REQUEST, payload);
export const listSavedFilingPeriodSpreadsheetsSuccess = response =>
  actionRequestFactory(types.LIST_SAVED_FILING_PERIOD_JSON_SUCCESS, response);
export const listSavedFilingPeriodSpreadsheetsFailure = error =>
  actionRequestFactory(types.LIST_SAVED_FILING_PERIOD_JSON_FAILURE, { error });

export const deleteSavedFilingPeriodSpreadsheetsRequest = payload =>
  actionRequestFactory(types.DELETE_SAVED_FILING_PERIOD_JSON_REQUEST, payload);
export const deleteSavedFilingPeriodSpreadsheetsSuccess = response =>
  actionResponseFactory(types.DELETE_SAVED_FILING_PERIOD_JSON_SUCCESS, response);
export const deleteSavedFilingPeriodSpreadsheetsFailure = response =>
  actionResponseFactory(types.DELETE_SAVED_FILING_PERIOD_JSON_FAILURE, response);

export const updateFilingOutcomeRequest = createAction(types.UPDATE_FILING_OUTCOME_REQUEST);
export const updatePaymentDetailsRequest = createAction(types.UPDATE_PAYMENT_DETAILS_REQUEST);
